import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const BenefitsSectionCard = styling("div")({
  width: "100%",
  padding: "2rem",
  background: Color.white,
  borderRadius: "0.75rem",
  outline: "1px solid #E8E8E8",
  outlineOffset: "-1px",

  "@media (max-width: 640px)": {
    padding: "1.25rem 1rem",
  },
});

export const BenefitsContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "1rem",
  marginTop: "1.25rem",

  "@media (max-width: 640px)": {
    display: "flex",
    flexDirection: "column",
    overflowX: "visible",
    padding: 0,
    gap: "0.75rem",
    marginTop: "0.75rem",
  },
});

export const CardStyled = styling("div")({
  backgroundColor: Color.white,
  boxShadow: "0 0 0 1px #D8D8D8",
  borderRadius: "0.5rem",
  padding: "1rem",
  width: "100%",
  minHeight: "10.5rem",
  display: "flex",
  alignItems: "flex-start",
  gap: "0.875rem",
  boxSizing: "border-box",

  transition: "box-shadow 0.15s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      "& h3": {
        transition: "all 0.2s ease-in-out",
        color: Color.hiredlyPurple,
      },
      boxShadow: `0 0 0 2px ${Color.hiredlyPurple}`,
    },
  },

  "@media (max-width: 640px)": {
    minWidth: 0,
    minHeight: 0,
    padding: "0.875rem",
    gap: "0.75rem",
  },
});

export const BenefitContent = styling("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
  minWidth: 0,
  overflowWrap: "anywhere",

  "@media (max-width: 640px)": {
    flex: 1,
    gap: "0.125rem",
  },
});

export const BenefitTitle = styling("h3")({
  margin: 0,
  color: "#000",
  fontSize: "15px",
  fontFamily: "Inter",
  fontWeight: 700,
  lineHeight: "21px",

  "@media (max-width: 640px)": {
    fontSize: "14px",
    lineHeight: "20px",
  },
});

export const BenefitDescription = styling("p")({
  margin: 0,
  color: "rgba(0, 0, 0, 0.60)",
  fontSize: "13px",
  fontFamily: "Karla",
  fontWeight: 400,
  lineHeight: "19.5px",

  "@media (max-width: 640px)": {
    fontSize: "12px",
    lineHeight: "18px",
  },
});

export const BenefitIconTile = styling("div")({
  width: "3rem",
  minWidth: "3rem",
  height: "3rem",
  borderRadius: "0.5rem",
  background: "#F5F0FF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "@media (max-width: 640px)": {
    width: "2.5rem",
    minWidth: "2.5rem",
    height: "2.5rem",
    borderRadius: "0.5rem",
  },
});

export const FontAwesomeIconStyled = styling(FontAwesomeIcon)({
  width: "1.25rem",
  height: "1.25rem",
  color: Color.hiredlyPurple,

  "@media (max-width: 1280px)": {
    width: "1.125rem",
    height: "1.125rem",
  },

  "@media (max-width: 640px)": {
    width: "1rem",
    height: "1rem",
  },
});
